import Env from '../../base/env'
import gsap from 'gsap'
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default class ProductGalleryMobile
{
    constructor(view) {
        this.$view = view
        this.$touchZone = this.$view.querySelector('.jsZoom--touchCollection')
        this.$items = this.$view.querySelectorAll('.jsItem')
        this.$anchorReceptor = this.$view.querySelector('.jsAnchors')
        this.$anchors = []
        this.TOTAL = this.$items.length
        if(this.TOTAL == 0) return false
        this.setup()
    }

    drawAnchors()
    {
        for(let i = 0; i < this.TOTAL; i++) {
            const $item = this.$items[i]
            $item.setAttribute('data-i',i);
            const anchor = document.createElement('div')
            anchor.classList.add('anchor')
            this.$anchorReceptor.appendChild(anchor)
            this.$anchors.push(anchor)
            anchor.addEventListener('click',()=>{
                this.goTo(i)
            })
        }
    }

    goTo(index)
    {
        const viewport = Env.framework.toolbox.getViewport()
        const newScrollPosition = viewport.width * index
        gsap.to(this.$touchZone , { duration: .6 , scrollTo: { x : newScrollPosition } , ease : "cubic.inOut" })
    }

    observe()
    {
        let options = {
            root: this.$view,
            rootMargin: '0px',
            threshold: .5
        }

        const observer = new IntersectionObserver(entries => {
            for(let i = 0; i < this.TOTAL; i++) {
                const $item = this.$items[i]
                $item.classList.remove('is--active')
                this.$anchors[i].classList.remove('is--active')
            }
            entries.forEach(elem => {
                    if (elem.isIntersecting) {
                        const $target = elem.target;
                        const $getAnchor = this.$anchors[$target.getAttribute('data-i') * 1]
                        $target.classList.add('is--active')
                        $getAnchor.classList.add('is--active')
                    }
                });
            },
        options)
        this.$items.forEach(elem => observer.observe(elem));
    }

    setup()
    {
        this.drawAnchors()
        this.observe()
        setTimeout(() => {
            this.$anchors[0].classList.add('is--active')
        }, 500);
    }
}
